export const fetchSuggestions = (queryString = {}) => {
    const queryStringStr = Object.keys(queryString).map(key => `${key}=${queryString[key]}`).join('&')

    return {
        method: 'GET',
        url: `/suggestions?${queryStringStr}`
    };
};
export const deleteSuggestion = ({ suggestionId }) => {
    return {
        method: 'DELETE',
        url: `/suggestions/${suggestionId}`
    };
};
export const updateSuggestion = ({ suggestionId, ...data }) => {
    return {
        method: 'PUT',
        url: `/suggestions/${suggestionId}`,
        data
    };
};

export const addSuggestion = (values) => {
    return {
        method: 'POST',
        url: '/suggestions',
        data: values
    };
};